var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';
import { default as AntInputNumber } from 'antd/lib/input-number';
import { basicPropTypes, controlPropTypes } from '../component-props';
import { services } from '@comall-backend-builder/core';

var Numberbox = function (_super) {
  __extends(Numberbox, _super);

  function Numberbox(props) {
    var _this = _super.call(this, props) || this;

    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  Numberbox.prototype.handleChange = function (value) {
    var _a = this.props,
        name = _a.name,
        onChange = _a.onChange;

    if (onChange) {
      onChange(value, name);
    }
  };

  Numberbox.prototype.shouldComponentUpdate = function (nextProps) {
    return !isEqual(this.props, nextProps);
  };

  Numberbox.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        style = _a.style,
        name = _a.name,
        value = _a.value,
        _b = _a.placeholder,
        placeholder = _b === void 0 ? services.language.getText('common.pleaseInput') : _b,
        disabled = _a.disabled,
        min = _a.min,
        max = _a.max,
        step = _a.step,
        formatter = _a.formatter;
    var numberboxProps = {
      // basicPropTypes
      className: className,
      style: style,
      // controlPropTypes
      name: name,
      value: value,
      placeholder: placeholder,
      disabled: disabled,
      onChange: this.handleChange,
      // custom
      min: min,
      max: max,
      step: step,
      formatter: formatter
    };
    return React.createElement(AntInputNumber, __assign({}, numberboxProps));
  };

  Numberbox.propTypes = __assign(__assign(__assign({}, basicPropTypes), controlPropTypes), {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    // 最小值
    min: PropTypes.number,
    // 最大值
    max: PropTypes.number,
    // 累加/累减的步长，支持小数
    step: PropTypes.number,
    formatter: PropTypes.func
  });
  return Numberbox;
}(Component);

export { Numberbox };